import React from 'react';
import { ReferencePage } from './ReferencePage';
import { ProductNewForm } from '../../components/ProductNewForm';
import { useData } from '../../contexts/DataContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { TABLE_COLUMNS } from '../../constants/tables';
import { ProductNew } from '../../types';

export const ProductsPage: React.FC = () => {
  const { t } = useLanguage();
  const { products, warehouses, contractors, contracts, productCategories } = useData();

  return (
    <ReferencePage<ProductNew>
      title={t('references.products')}
      items={products.items}
      columns={TABLE_COLUMNS.PRODUCTS}
      onAdd={products.add}
      onEdit={products.edit}
      onDelete={products.remove}
      renderForm={({ theme, initialData, onSubmit, onCancel }) => (
        <ProductNewForm
          theme={theme}
          warehouses={warehouses.items}
          contractors={contractors.items}
          contracts={contracts.items}
          categories={productCategories.items}
          initialData={initialData}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      )}
    />
  );
};
